<template>
  <v-container fluid>
    <v-layout row wrap >
      <v-flex xs2 md2 >
        <v-btn color="primary" dark text @click="showStockDialog(true)" >新增</v-btn>
      </v-flex>
      <v-flex xs2 md2 >
        <v-btn color="primary" dark text @click="showStock()" >查詢庫存</v-btn>
      </v-flex>
    </v-layout>

    <!-- <v-layout  mt-2>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="search.startDate" />
      </v-flex>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="search.endDate" />
      </v-flex>
    </v-layout> -->

    <v-layout xs12>
      <v-flex xs5 md3>
        <v-select
          :items="typeKeys"
          item-text="text"
          item-value="key"
          v-model="typeStatus"
          @change="changeTypeStatus()"
        ></v-select>
      </v-flex>
        <!-- <v-flex md2 xs8 >
          <v-select :items="searchKeys"
                        item-text="value"
                        item-value="key"
                        v-model="search.searchKey"
                        label="查詢條件"
          ></v-select>
        </v-flex> -->
        <!-- <v-flex ml-2 md5 xs8 v-if="search.searchKey === `vendor` ">
          <v-select :items="searchKeys"
                        item-text="value"
                        item-value="key"
                        v-model="search.keyword"
                        label="搜尋名稱"
          ></v-select>
        </v-flex>
        <v-flex ml-2 md5 xs8 v-else>
          <v-text-field v-model="search.keyword" :label="`搜尋名稱`" :placeholder="search.placeholder"
          @keyup.enter="searchEvent"></v-text-field>
        </v-flex> -->
        <v-flex md4 xs4>
          <v-btn color="success" @click="searchEvent">搜尋</v-btn>
          <v-btn color="warning" @click="reset">重置</v-btn>
        </v-flex>
    </v-layout>
    <v-layout row wrap >
      <table-view :columnKeys="columnKeys"
                :items="items"
                :loading="loading"
                :total-items="totalItems"
                @cellEvent="cellEvent"
                  @changePage="changePage"
                @handleLoadData="reset">
      </table-view>
    </v-layout>

    <v-dialog v-model="stockListDialog.visible"
              no-click-animation
              max-width="60%">
      <v-card>
        <v-card-title>{{stockListDialog.title}}</v-card-title>
        <v-card-text>
          <v-flex xs4 md2 pr-3>
            <v-select
              :items="typeKeys"
              item-text="text"
              item-value="key"
              v-model="stockListDialog.type"
              @change="loadStockList()"
            ></v-select>
          </v-flex>
          <v-layout row wrap >
            <table-view :columnKeys="stockColumnKeys"
                      :items="stockListDialog.items"
                      @handleLoadData="loadStockList">
            </table-view>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" dark text @click="stockListDialog.cancel">取消</v-btn>
            <v-btn class="primary" dark text @click="stockListDialog.confirm">確定</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :isHtmlContent="true"
                :showCancel="messageDialog.showCancelButton"
                @cancelEvent="messageDialog.cancel"
                @confirmEvent="messageDialog.confirm"></alert-view>
    <stock-edit-dialog :visible="stockDialog.visible"
      :title="stockDialog.title"
      :item="stockDialog.item"
      :isNew="stockDialog.isNew"
      :categoryList="categoryList"
      :typeList="typeKeys"
      :productList="productsList"
      :statusKey="statusKey"
      @confirmEvent="stockDialog.confirm"
      @cancelEvent="stockDialog.cancel"></stock-edit-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MobileDetect from "mobile-detect";

import AlertView from '@/components/AlertView';
import TableView from '@/components/TableView';
import { getCurrentDate } from '@/pages/utils/tool';
import DatePicker from "@/components/DatePicker";
import StockModel from "../../models/StockModel";
import StockEditDialog from "@/components/StockEditDialog";

const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: "StockManagerView",
  components: {
    AlertView,
    TableView,
    DatePicker,
    StockEditDialog
  },
  data() {
    return {
      loading: false,
      isMobile: md.phone(),
      pageIndex: 1,
      limit: 5,
      totalItems: 0,
      typeStatus:0,
      search: {
        keyword: "",
        placeholder: "搜尋名稱",
        startDate:  '2021-01-01',
        endDate:  '2121-01-01',
        searchKey:'carName',
      },
      items: [],
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      stockDialog:{
        title: "",
        visible: false,
        isNew:false,
        item: new StockModel(),
        confirm: () => {},
        cancel: () => {},
      },
      stockListDialog:{
        title:"",
        visible:false,
        type:0,
        items:[],
        confirm: () => {},
        cancel: () => {},
      },
      products: [],
    };
  },
  created() {
    this.loadData(this.pageIndex, this.limit);
    this.loadProductList();
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList"]),
    columnKeys() {
      const list = [
        { value: "edit", text: "操作", sortable: false, required: false , color:'primary', isEvent: true},
        { value: "productNumber", text: "商品編號", sortable: true, required: false },
        { value: "productId", text: "商品名稱", sortable: true, required: false, options: this.productsList, isSelect: true},
        { value: "status", text: "狀態", sortable: true, required: false , options: this.statusKey, isSelect: true},
        { value: "count", text: "數量", sortable: true, required: false },
        { value: "price", text: "單價", sortable: true, required: false },
        { value: "comment", text: "備註", sortable: true, required: false },
        { value: "createdDate", text: "建立時間", sortable: true, required: false }];
      return list
    },
    stockColumnKeys() {
      const list = [
        { value: "generalNumber", text: "商品編號", sortable: true, required: false },
        { value: "count", text: "數量", sortable: true, required: false }]
      return list
    },
    getTotalItems() {
      return this.totalItems;
    },
    categoryList() {
      return [
        { key: 0, text: "整新品" },
        { key: 1, text: "維修交換品"},
        { key: 2, text: "維修品"},
        { key: 3, text: "故障品"},
      ];
    },
    typeKeys() {
      return [
        { key: 0, text: "整流器" },
        { key: 1, text: "ECU" },
      ];
    },
    productsList() {
      let list = [];
      for(let i = 0; i< this.products.length; i++){
        const item = this.products[i]
        list.push({key:`${item.productId}`,text: `${item.id}`})
      }
      return list;
    },
    searchKeys() {
      return [
        { key: "productNumber", value: "商品編號" },
        { key: "productId", value: "商品名稱" },
        { key: "category", value: "類型" },
        { key: "status", value: "狀態" },
      ];
    },
    statusKey() {
      return [{ key: 0, text: "未出售" },
        { key: 1, text: "已出售" },
        { key: 2, text: "已退貨" },
        { key: 3, text: "故障品" },]
    }
  },
  methods: {
    ...mapActions([
      "stockCreate",
      "stockUpdate",
      "stockList",
      "stockTypeList",
      "stockInfo",
      "motoList",
      "stockTypeList"
    ]),
    setDefualtDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.search.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.search.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    changePage(page) { // 改變頁數 or 每頁筆數
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData(this.pageIndex, this.limit);
    },
    changeTypeStatus(){
      this.loadData(this.pageIndex, this.limit);
    },
    async loadData(pageIndex, limit, isExport=false) {
      this.loading = true;
      let searchQuery = [{ "key" :`type` , "value":`${this.typeStatus}`}]
      if(this.search.searchKey && this.search.keyword) {
        searchQuery.push({ "key" :`${this.search.searchKey}` , "value":`${this.search.keyword}`})
      }
      const data = {
        startDate: `${this.search.startDate} 00:00:00`,
        endDate: `${this.search.endDate} 23:59:59`,
        pageIndex: pageIndex,
        limit: limit,
        searchQuery: searchQuery
      };
      const results = await this.stockList(data);

      this.items = results.data.data.list;
      this.totalItems = results.data.data.header.totalCount;
      this.loading = false;
    },
    async showStock(){
      this.stockListDialog.visible = true
      await this.loadStockList()
      const self = this;
      this.stockListDialog.confirm = () => {
        self.stockListDialog.visible = false;
      };
      this.stockListDialog.cancel = () => {
        self.stockListDialog.visible = false;
      };
    },
    async loadStockList(){
      const results = await this.stockTypeList({
        type:this.stockListDialog.type
      })
      this.stockListDialog.items = results.data.data
      console.log(`result ${JSON.stringify(results)}`)
    },
    async loadProductList(){
      const data = {
        startDate: `${this.search.startDate} 00:00:00`,
        endDate: `${this.search.endDate} 23:59:59`,
        pageIndex: this.pageIndex,
        limit: -1,
        searchQuery: []
      };
      const results = await this.motoList(data);
      this.products = results.data.data.list;
    },
    cellEvent(props) { // cell 按鈕事件 (用Key判斷是點選哪一個
      console.log(`cellEvent ${JSON.stringify(props)}`)
      if (props.key === 'edit'){
        this.showStockDialog(false, props.item)
      }
    },
    exportData() {
      this.loadData(1, 10000, true);
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    searchEvent() {
      this.loadData(this.pageIndex, this.limit);
    },
    reset(){
      this.search.keyword = ''
      this.loadData(this.pageIndex, this.limit);
    },
    showStockDialog(isNew, info = new StockModel()){
      this.stockDialog.visible = true
      this.stockDialog.item = info
      let title = "商品庫存"
      this.stockDialog.title = isNew ? `新增${title}` : `編輯${title}`
      this.stockDialog.isNew = isNew
      this.stockDialog.confirm = (item) => {
        this.stockDialog.visible = false
        this.editStock(item, isNew)
      }
      this.stockDialog.cancel = () => {
        this.stockDialog.visible = false
      }
    },
    async editStock(item, isNew) {
      let results = isNew ? await this.stockCreate(item) : await this.stockUpdate(item)

      this.stockDialog.visible = false
      this.showMessageDialog("提示",results.data.message,true,
        () => {
          this.messageDialog.visible = false
        })
      await this.loadData(this.pageIndex, this.limit);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/web/StockManagerView.vue